import { VueConstructor } from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas, faArrowUp, faChevronRight, faCode, faCog, faSignOutAlt, faCheckCircle, faTimesCircle, faExclamationCircle, faCamera, faPlus, faCheck, faTimes, faTrash, faEdit, faSave, faUserShield, faTruck, faTractor, faCar, faSearch, faQuestion, faPhone, faExclamation } from '@fortawesome/free-solid-svg-icons'
import { faCss3Alt, faDev } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faArrowUp)
library.add(faChevronRight)
library.add(faCode)
library.add(faCog)
library.add(faCss3Alt)
library.add(faDev)
library.add(faSignOutAlt)
library.add(faCheck)
library.add(faTimes)
library.add(faCheckCircle)
library.add(faTimesCircle)
library.add(faExclamationCircle)
library.add(faCamera)
library.add(faPlus)
library.add(faTrash)
library.add(faEdit)
library.add(faSave)
library.add(faUserShield)
library.add(faTruck)
library.add(faTractor)
library.add(faCar)
library.add(faQuestion)
library.add(faPhone)
library.add(faExclamation)
library.add(fas)

export default (vue: VueConstructor) => {
  vue.component('font-awesome-icon', FontAwesomeIcon)
}
